var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4724_16327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32691 2.4856C5.69342 2.4856 2.73389 5.44513 2.73389 9.07862C2.73389 12.7121 5.69342 15.6716 9.32691 15.6716C12.9604 15.6716 15.9199 12.7121 15.9199 9.07862C15.9199 5.44513 12.9604 2.4856 9.32691 2.4856ZM9.32691 14.7706C6.18424 14.7706 3.63493 12.214 3.63493 9.07862C3.63493 5.94327 6.19156 3.38664 9.32691 3.38664C12.4623 3.38664 15.0189 5.94327 15.0189 9.07862C15.0189 12.214 12.4623 14.7706 9.32691 14.7706Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6933 6.71255C11.5248 6.54406 11.2244 6.54406 11.056 6.71255L9.32712 8.44138L7.59829 6.71255C7.4298 6.54406 7.12945 6.54406 6.96096 6.71255C6.78515 6.88836 6.78515 7.17406 6.96096 7.34987L8.6898 9.07871L6.96096 10.8075C6.78515 10.9834 6.78515 11.2691 6.96096 11.4449C7.12945 11.6134 7.4298 11.6134 7.59829 11.4449L9.32712 9.71604L11.056 11.4449C11.1439 11.5328 11.2538 11.5767 11.371 11.5767C11.4882 11.5767 11.6054 11.5328 11.686 11.4449C11.8618 11.2691 11.8618 10.9834 11.686 10.8075L9.95712 9.07871L11.686 7.34987C11.8618 7.17406 11.8618 6.88836 11.686 6.71255H11.6933Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4724_16327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5814,
    height: 17.5814,
    fill: "white",
    transform: "translate(0.536133 0.288086)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundIcon);
export default __webpack_public_path__ + "static/media/closeRoundIcon.0df0e29a2743fb4d788b28a641c12f05.svg";
export { ForwardRef as ReactComponent };